// Types
import { ProductProps } from 'types/Product.types';

export function getItemUndeliverableReason(items: ProductProps[], id: string) {
  const item = items.find((i) => i.id === id);

  if (!item) {
    return { reasons: [] };
  }

  return {
    reasons: item.undeliverableReasons ?? [],
  };
}
